import script from "./action-card-caption.vue?vue&type=script&setup=true&lang=ts"
export * from "./action-card-caption.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__